const bus = new Vue();

export default bus;
